export { default as CategoryDimensionsQuery } from './CategoryDimensionsQuery';